/* eslint-disable react-hooks/exhaustive-deps */
import { gql, useLazyQuery } from '@apollo/client';
import { Box, FormControl, FormHelperText, FormLabel, Select } from '@chakra-ui/react';
import { Field } from 'formik';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import c from '../../constant';
import useStore from '../../store';
import { isAdminUser } from '../../containers/ReportDue/Common/Utils';

const Q_REPORTS = gql`
	query get($period: String!) {
		getPublicCompanyReportTypes(period: $period) {
			id
			title
			titleKh
			period
			departments
		}
	}
`;

export default function CompanyReportTypeFormField({ name = null, label = null, period = null, placeholder = null, required = false }) {
	const { t } = useTranslation('common');
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const { currentUser: user } = useStore((state) => state?.currentUser);
	const [loadReports, { data }] = useLazyQuery(Q_REPORTS);

	useEffect(load, [period]);

	const reports = useMemo(() => {
		if (isAdminUser(user)) {
			return data?.getPublicCompanyReportTypes ?? [];
		} else {
			const userDepartments = user?.department?.split(',') ?? [];
			const localReports = data?.getPublicCompanyReportTypes?.filter((item) => {
				const reportDepartments = item?.departments?.split(',') ?? [];
				return userDepartments?.some((department) => reportDepartments?.includes(department));
			});
			return localReports;
		}
	}, [data]);

	function load() {
		const periods = ['monthly', 'quarterly', 'semesterly', 'annually'];
		const status = periods?.includes(period?.toLowerCase());
		if (status) loadReports({ variables: { period: period?.toUpperCase() } });
	}

	return (
		<Field name={name}>
			{({ field, meta, form }) => {
				return (
					<Box mb="4" overflow="hidden">
						<FormControl id={name}>
							{label && (
								<FormLabel>
									{t(label)}
									{required && <span style={{ color: 'red' }}>*</span>}
								</FormLabel>
							)}
							<Select
								{...field}
								h={12}
								value={field?.value}
								onChange={(e) => form?.setFieldValue(name, e.target.value)}
								placeholder={placeholder}
								borderRadius={c.borderRadius}
								isInvalid={meta.touched && meta.error}
								errorBorderColor="red.300"
							>
								{reports?.map((item, index) => {
									return (
										<option key={`option-item-${index}`} value={item?.id}>
											{lang === 'kh' ? item?.titleKh : item?.title}
										</option>
									);
								})}
							</Select>
							{meta.touched && meta.error && (
								<FormHelperText id="error-message-password" color="red.400" fontSize="12px">
									{t(label)} {t('is')} {t(meta.error)}
								</FormHelperText>
							)}
						</FormControl>
					</Box>
				);
			}}
		</Field>
	);
}
